import React, { useState } from "react";
import {
  NewsPopular,
  NewsSearch,
  NewsSubscription,
  NewsTags,
  NewsThumbCard,
} from "@modules/study/common/news";
import PlayButtonWithRipple from "@modules/study/common/play_btn_with_ripple";
import dynamic from "next/dynamic";
import { getAssets, htmlParse } from "@unisearch/helpers";
const UniComment = dynamic(() => import("@modules/study/common/comment"), {
  ssr: false,
});
const baseUrl = process.env.NEXT_PUBLIC_URL;
import { useMediaQuery } from "react-responsive";
const ModalVideo = dynamic(() => import("react-modal-video"), { ssr: false });
import styles from "./detail.module.scss";

export const GalleryDetailSection = ({
  newsDetails,
  popularStories,
  tagsList,
  format,
}) => {
  const [isOpenVideo, setOpenVideo] = useState(false);

  const isMobile = useMediaQuery({
    query: "(max-width: 900px)",
  });

  return (
    <>
      <section>
        <div className="container">
          <div className={styles.list_wrapper}>
            <div className={styles.left_side}>
              {isMobile && (
                <NewsSearch
                  customClasses={{
                    wrapperClass: styles.search_wrapper_calss,
                  }}
                />
              )}
              <div className={styles.detail_wrapper}>
                {/* form video format */}
                {format === "video" && (
                  <>
                    {newsDetails?.videoType &&
                      newsDetails?.videoType === "embeded" && (
                        <div
                          className={`${styles.detail_video_wrapper} relative`}
                        >
                          <iframe
                            width="560"
                            height="315"
                            src={`https://www.youtube.com/embed/${newsDetails?.embedCode}`}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
                        </div>
                      )}
                    {newsDetails?.videoType &&
                      newsDetails?.videoType === "upload" && (
                        <div
                          className={`${styles.detail_video_wrapper} relative`}
                        >
                          <PlayButtonWithRipple
                            onClick={() => setOpenVideo(true)}
                          />
                          <img
                            src={
                              newsDetails?.posterImage
                                ? newsDetails.posterImage.src
                                : newsDetails?.featureImage?.src ||
                                  getAssets(
                                    "assets/images/image_placeholder_big.webp"
                                  )
                            }
                            alt={
                              newsDetails?.posterImage
                                ? newsDetails.posterImage.alt
                                : newsDetails?.featureImage?.alt ||
                                  "Video Poster"
                            }
                          />
                        </div>
                      )}
                  </>
                )}

                <div className="from_texteditor_wrapper">
                  {htmlParse(newsDetails.newsContent)}
                </div>
              </div>

              {/* <div className={styles.comment_container}>
                <UniComment
                  commentType="news"
                  referenceId={newsDetails?.newsId}
                />
              </div> */}
            </div>
            <div className={styles.right_side}>
              {!isMobile && <NewsSearch />}
              <NewsSubscription />
              <NewsPopular data={popularStories} />
              <NewsTags tagsList={tagsList} format={format} />
            </div>
          </div>
        </div>
      </section>

      <ModalVideo
        channel="custom"
        autoplay
        isOpen={isOpenVideo}
        url={newsDetails?.videoUpload?.src}
        onClose={() => setOpenVideo(false)}
      />
    </>
  );
};

export default GalleryDetailSection;
